import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/file.png'


const _withScopeId = n => (_pushScopeId("data-v-3cc56554"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid p-col-12" }
const _hoisted_2 = { class: "p-col-11" }
const _hoisted_3 = { class: "p-d-flex p-ai-center title" }
const _hoisted_4 = { class: "p-d-flex p-ai-center" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "p-d-flex p-ai-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_8 = { class: "title sub-number" }
const _hoisted_9 = { class: "p-d-flex p-ai-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "button" }
const _hoisted_14 = { class: "button-more" }
const _hoisted_15 = { class: "details-window" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View Details", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DataTable, {
        value: $setup.transfers,
        responsiveLayout: "scroll",
        rows: 8
      }, {
        empty: _withCtx(() => [
          _createTextVNode("No data found.")
        ]),
        loading: _withCtx(() => [
          _createTextVNode("Loading data... Please wait.")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: "Payment number",
            sortable: "",
            sortField: "transferId"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_3, "#" + _toDisplayString(data?.id), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "DATE",
            sortable: "",
            sortField: "CreationDate"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString($setup.formatDate(data?.createdAt)), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Campaign Name",
            sortable: "",
            sortField: "submissionInfo.submissionId"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString(data?.campaignId?.name) + " - ", 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Brand",
            sortable: "",
            sortField: "brand?.name"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_9, [
                (data?.brand?.photo && data?.brand?.photo.length > 0)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: data?.brand?.photo,
                      class: "logo-brand"
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_11, _toDisplayString(data?.brand?.name), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "AMOUNT",
            sortable: "",
            sortField: "amount"
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", _hoisted_12, _toDisplayString(data?.amount) + " " + _toDisplayString(data?.currency), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, null, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_13, [
                _createTextVNode("... "),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("a", {
                      href: data?.creditNode,
                      target: "_blank",
                      download: ""
                    }, "View Invoice", 8, _hoisted_16),
                    _hoisted_17
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ])
  ]))
}